import { Link } from "react-router-dom";
import { globalT } from "../utils/globalUtils.js";

export default function SelectorInit(props) {
  return (
    <Link
      className={`m-selectorInit ${props.img ? "" : "no-icon"}`}
      id={props.id}
      to={props.path}
    >
      {props.img && (
        <div className="m-sel-icon" style={{ backgroundColor: props.color }}>
          <img
            className={props.imgClassName || ""}
            src={`/images/` + props.img}
            alt=""
          />
        </div>
      )}
      <div className="m-sel-cont">
        <div className="m-title">{props.title}</div>
        <div className="m-text">{props.text}</div>
        <div className="m-link">{`${globalT("Acceder ahora")} >>`}</div>
      </div>
    </Link>
  );
}
